import { Route } from '@angular/router';
import { authGuard } from '@kempower-nx-workspace/ctep-event-log-app-core';
import { ChargerLookupLandingComponent } from './feature/charger-lookup-landing/charger-lookup-landing.component';
import { EventLogResultComponent } from './feature/event-log-result/event-log-result.component';
import { LoginComponent } from './feature/login/login.component';

export const eventLogPageRoutes: Route[] = [
    { path: '', pathMatch: 'full', redirectTo: 'logs' },
    { path: 'login', component: LoginComponent },
    { path: 'logs', component: ChargerLookupLandingComponent, canActivate: [authGuard] },
    { path: 'logs/result/:chargerId', component: EventLogResultComponent, canActivate: [authGuard] },
];
